import React, { useEffect, useMemo } from "react";
import { FormGroup, SubmitButton } from "components/common";
import { Button, Col, Label } from "reactstrap";
import { Trans, useTranslation } from "react-i18next";
import { NotificationManager } from "react-notifications";
import { useCustomModal } from "services/useBaseModal";
import { LocalForm, Control } from "react-redux-form";
import Select from "react-select";
import { useQuery } from "react-query";
import { useXeroClient } from "hooks";

export default function ReportsSettings({ settings, setSettings, isPartial }) {

    const [, SettingsToggle, SettingsModal] = useCustomModal();
    const xero = useXeroClient();
    const { t } = useTranslation();

    const { data: contacts } = useQuery(['contacts'], () => xero.get("contacts").get("data"))
    const { data: taxRates } = useQuery(['taxrates'], () => xero.get("taxrates").get("data"))
    const { data: _settings } = useQuery(['settings'], () => xero.get("reports-settings").get("data"))

    const taxrates_options = useMemo(() => {
        return taxRates?.map((rate) => {
            if ((settings?.tax_exempt?.includes(rate.TaxType) || settings?.domestic_sales?.includes(rate.TaxType) || settings?.country_bears?.includes(rate.TaxType)))
                return { ...rate, disabled: true }
            return rate
        }
        )
    }, [settings, taxRates])

    useEffect(() => {
        if (_settings) {
            setSettings(_settings)
        }
    }, [_settings])

    const updateSettings = async (values) => {
        try {
            if (settings.id) {
                await xero.patch(`reports-settings/${settings.id}`, { ...values })
            } else {
                await xero.post('reports-settings', { ...values })
            }
            SettingsToggle();
            NotificationManager.success(t('Saved successfully'))
        }
        catch (ex) {
            NotificationManager.error(t("An unexpected error occurred"));
        }
    }

    return (
        <>
            <div className="d-flex align-items-end">
                <FormGroup >
                    <Label>&nbsp;</Label>
                    <Button
                        color="primary"
                        className="d-block"
                        onClick={SettingsToggle}
                    >
                        <Trans><i className="fa fa-cogs" aria-hidden="true"></i></Trans>
                    </Button>
                </FormGroup>
            </div>
            <SettingsModal
                title={'Tax Rate Settings'}
                body={settings &&
                    <div>
                        <LocalForm initialState={settings} onSubmit={updateSettings} onChange={setSettings}>
                            {!isPartial && <>
                                <Col className="col-12">
                                    <FormGroup addControlClass={false} label={t("Tax Exempt Rates*")} model=".tax_exempt" className="mb-3">
                                        <Control.text
                                            model=".tax_exempt"
                                            component={Select}
                                            options={taxrates_options}
                                            multi={true}
                                            simpleValue
                                            clearable={false}
                                            labelKey="Name"
                                            valueKey="TaxType"
                                            searchable={false}>
                                        </Control.text>
                                    </FormGroup>
                                </Col>
                                <Col className="col-12">
                                    <FormGroup addControlClass={false} label={t("Domestic Sales*")} model=".domestic_sales" className="mb-3">
                                        <Control.text
                                            model=".domestic_sales"
                                            component={Select}
                                            options={taxrates_options}
                                            multi={true}
                                            simpleValue
                                            clearable={false}
                                            labelKey="Name"
                                            valueKey="TaxType"
                                            searchable={false}>
                                        </Control.text>
                                    </FormGroup>
                                </Col>
                                <Col className="col-12">
                                    <FormGroup addControlClass={false} label={t("Country Bears*")} model=".country_bears" className="mb-3">
                                        <Control.text
                                            model=".country_bears"
                                            component={Select}
                                            options={taxrates_options}
                                            multi={true}
                                            simpleValue
                                            clearable={false}
                                            labelKey="Name"
                                            valueKey="TaxType"
                                            searchable={false}>

                                        </Control.text>
                                    </FormGroup>
                                </Col>
                            </>}

                                <div className="my-3">
                                    <span><Control.checkbox model=".use_pos" /> <Trans>Using POS</Trans></span>
                                    <span className="d-block my-2 hint small text-muted"><Trans>If checked, invoices with lines that have "Tax" or "Taxes" or with account code "802" are treated as tax lines, other amounts will based on the tax value</Trans></span>
                                </div>
                            <div className="d-flex my-4 justify-content-end">
                                <Button className="mx-2" color="secondary" onClick={SettingsToggle}><Trans>Cancel</Trans></Button>
                                <SubmitButton className="mx-2" color="primary"> <Trans>Save</Trans></SubmitButton>
                            </div>
                        </LocalForm>
                    </div>}
            />
        </>
    )
}